import React, { useState } from 'react';
import './TransformationAssessment.css';

const TransformationAssessment = () => {
  const [currentQuestion, setCurrentQuestion] = useState(1);
  const [answers, setAnswers] = useState({});
  const [showResults, setShowResults] = useState(false);
  const [showDestinationCard, setShowDestinationCard] = useState(false);
  const [selectedDestination, setSelectedDestination] = useState('');

  const totalQuestions = 10;

  const questions = [
    {
      num: 1,
      title: 'What do you want from travel?',
      options: [
        { value: 'peace', icon: '🧘', title: 'Find Inner Peace', desc: 'Relax and reconnect with yourself' },
        { value: 'confidence', icon: '💪', title: 'Build Confidence', desc: 'Push boundaries and grow stronger' },
        { value: 'adventure', icon: '🌟', title: 'Seek Adventure', desc: 'Explore new places and experiences' },
        { value: 'creativity', icon: '🎨', title: 'Get Inspired', desc: 'Unlock creativity and new ideas' }
      ]
    },
    {
      num: 2,
      title: 'How adventurous are you?',
      options: [
        { value: 'gentle', icon: '🌱', title: 'Keep It Comfortable', desc: 'Stay within my comfort zone' },
        { value: 'moderate', icon: '🌿', title: 'Some Challenge', desc: 'Push myself a little' },
        { value: 'extreme', icon: '🦅', title: 'Maximum Challenge', desc: 'Go all out and test my limits' }
      ]
    },
    {
      num: 3,
      title: 'How do you like to travel?',
      options: [
        { value: 'solo', icon: '🎒', title: 'Solo Journey', desc: 'Travel alone for self-discovery' },
        { value: 'cultural', icon: '🌍', title: 'Cultural Immersion', desc: 'Connect with locals and traditions' },
        { value: 'wellness', icon: '🧘♀️', title: 'Wellness Focus', desc: 'Prioritize health and healing' },
        { value: 'guided', icon: '👨🏫', title: 'Expert Guidance', desc: 'Learn from local guides' }
      ]
    },
    {
      num: 4,
      title: 'How long can you travel?',
      options: [
        { value: 'weekend', icon: '⚡', title: 'Weekend Getaway', desc: '3-4 days of quick transformation' },
        { value: 'week', icon: '📅', title: 'One Week', desc: 'Perfect for most schedules' },
        { value: 'two_weeks', icon: '🌙', title: 'Two Weeks', desc: 'Deep, meaningful experience' },
        { value: 'month_plus', icon: '🌍', title: 'A Month or More', desc: 'Life-changing journey' }
      ]
    },
    {
      num: 5,
      title: 'What\'s your budget range?',
      options: [
        { value: 'budget', icon: '💰', title: '$1,000 - $3,000', desc: 'Great value experiences' },
        { value: 'moderate', icon: '💎', title: '$3,000 - $7,000', desc: 'Comfortable travel with extras' },
        { value: 'premium', icon: '👑', title: '$7,000+', desc: 'Luxury and premium experiences' }
      ]
    },
    {
      num: 6,
      title: 'What activities excite you most?',
      options: [
        { value: 'meditation', icon: '🧘', title: 'Meditation & Mindfulness', desc: 'Inner peace practices' },
        { value: 'outdoor', icon: '🏔️', title: 'Outdoor Adventures', desc: 'Hiking, nature, physical challenges' },
        { value: 'cultural', icon: '🎭', title: 'Cultural Experiences', desc: 'Art, music, local traditions' },
        { value: 'learning', icon: '📖', title: 'Learning & Skills', desc: 'New knowledge and abilities' }
      ]
    },
    {
      num: 7,
      title: 'Where do you prefer to stay?',
      options: [
        { value: 'luxury', icon: '🏨', title: 'Luxury Hotels', desc: 'Premium comfort and service' },
        { value: 'boutique', icon: '🏡', title: 'Unique Properties', desc: 'Character-filled places' },
        { value: 'local', icon: '🏠', title: 'Local Homestays', desc: 'Authentic cultural immersion' },
        { value: 'nature', icon: '⛺', title: 'Nature Lodges', desc: 'Eco-friendly wilderness stays' }
      ]
    },
    {
      num: 8,
      title: 'When do you prefer to travel?',
      options: [
        { value: 'spring', icon: '🌸', title: 'Spring', desc: 'Fresh beginnings, mild weather' },
        { value: 'summer', icon: '☀️', title: 'Summer', desc: 'Peak activity, long days' },
        { value: 'autumn', icon: '🍂', title: 'Autumn', desc: 'Reflection, beautiful colors' },
        { value: 'winter', icon: '❄️', title: 'Winter', desc: 'Quiet introspection, cozy vibes' }
      ]
    },
    {
      num: 9,
      title: 'How social do you want to be?',
      options: [
        { value: 'solo_focus', icon: '🚶', title: 'Mostly Alone', desc: 'Focus on personal growth' },
        { value: 'small_group', icon: '👥', title: 'Small Groups', desc: 'Meet like-minded travelers' },
        { value: 'local_connections', icon: '🤝', title: 'Connect with Locals', desc: 'Deep cultural exchange' }
      ]
    },
    {
      num: 10,
      title: 'What motivates you most?',
      options: [
        { value: 'physical', icon: '💪', title: 'Physical Challenges', desc: 'Test my body and endurance' },
        { value: 'mental', icon: '🧠', title: 'Mental Growth', desc: 'Learn and expand my mind' },
        { value: 'spiritual', icon: '✨', title: 'Spiritual Journey', desc: 'Find deeper meaning and purpose' },
        { value: 'creative', icon: '🎨', title: 'Creative Inspiration', desc: 'Unlock new ideas and perspectives' }
      ]
    }
  ];

  const selectOption = (value) => {
    setAnswers({ ...answers, [currentQuestion]: value });
  };

  const nextQuestion = () => {
    if (!answers[currentQuestion]) {
      alert('Please select an answer to continue.');
      return;
    }

    if (currentQuestion < totalQuestions) {
      setCurrentQuestion(currentQuestion + 1);
    } else {
      setShowResults(true);
    }
  };

  const previousQuestion = () => {
    if (currentQuestion > 1) {
      setCurrentQuestion(currentQuestion - 1);
    }
  };

  const calculateScores = () => {
    let spiritual = 0, adventure = 0, cultural = 0, wellness = 0;

    if (answers[1] === 'peace') { spiritual += 40; wellness += 30; }
    if (answers[1] === 'confidence') { adventure += 35; wellness += 10; }
    if (answers[1] === 'adventure') { adventure += 40; }
    if (answers[1] === 'creativity') { cultural += 35; spiritual += 10; }

    if (answers[2] === 'extreme') { adventure += 30; }
    if (answers[2] === 'moderate') { adventure += 15; cultural += 10; }
    if (answers[2] === 'gentle') { wellness += 20; spiritual += 15; }

    if (answers[3] === 'solo') { spiritual += 25; }
    if (answers[3] === 'cultural') { cultural += 35; }
    if (answers[3] === 'wellness') { wellness += 35; }
    if (answers[3] === 'guided') { cultural += 20; adventure += 10; }

    if (answers[4] === 'weekend') { adventure += 10; wellness += 15; }
    if (answers[4] === 'week') { cultural += 10; }
    if (answers[4] === 'two_weeks') { spiritual += 15; cultural += 10; }
    if (answers[4] === 'month_plus') { spiritual += 20; cultural += 15; }

    if (answers[5] === 'budget') { adventure += 10; cultural += 15; }
    if (answers[5] === 'moderate') { wellness += 10; }
    if (answers[5] === 'premium') { wellness += 15; spiritual += 10; }

    if (answers[6] === 'meditation') { spiritual += 35; wellness += 25; }
    if (answers[6] === 'outdoor') { adventure += 30; wellness += 10; }
    if (answers[6] === 'cultural') { cultural += 30; }
    if (answers[6] === 'learning') { cultural += 20; spiritual += 15; }

    if (answers[7] === 'luxury') { wellness += 15; }
    if (answers[7] === 'boutique') { cultural += 15; }
    if (answers[7] === 'local') { cultural += 20; spiritual += 10; }
    if (answers[7] === 'nature') { adventure += 15; wellness += 10; }

    if (answers[8] === 'spring') { wellness += 10; }
    if (answers[8] === 'summer') { adventure += 15; }
    if (answers[8] === 'autumn') { spiritual += 10; cultural += 10; }
    if (answers[8] === 'winter') { spiritual += 15; wellness += 5; }

    if (answers[9] === 'solo_focus') { spiritual += 20; }
    if (answers[9] === 'small_group') { adventure += 10; wellness += 10; }
    if (answers[9] === 'local_connections') { cultural += 25; }

    if (answers[10] === 'physical') { adventure += 25; }
    if (answers[10] === 'mental') { cultural += 25; }
    if (answers[10] === 'spiritual') { spiritual += 30; }
    if (answers[10] === 'creative') { cultural += 20; spiritual += 10; }

    const total = spiritual + adventure + cultural + wellness;
    return {
      spiritual: Math.round((spiritual / total) * 100),
      adventure: Math.round((adventure / total) * 100),
      cultural: Math.round((cultural / total) * 100),
      wellness: Math.round((wellness / total) * 100)
    };
  };

  const selectJourneyStyle = (style) => {
    if (style === 'ai-surprise') {
      sessionStorage.setItem('assessmentResults', JSON.stringify({ answers, scores: calculateScores() }));
      window.location.hash = 'recommendations';
    } else {
      setShowDestinationCard(true);
    }
  };

  const proceedWithDestination = () => {
    if (!selectedDestination) {
      alert('Please select a destination');
      return;
    }
    sessionStorage.setItem('assessmentResults', JSON.stringify({ answers, scores: calculateScores(), destination: selectedDestination }));
    window.location.hash = 'recommendations';
  };

  const progress = (currentQuestion / totalQuestions) * 100;
  const question = questions[currentQuestion - 1];
  const scores = calculateScores();

  if (showDestinationCard) {
    return (
      <div className="assessment">
        <div className="container">
          <div className="results-card active">
            <h2>🌍 Choose Your Dream Destination</h2>
            <p style={{ textAlign: 'center', marginBottom: '2rem' }}>We'll create a personalized transformation journey based on your profile and chosen destination.</p>

            <select
              value={selectedDestination}
              onChange={(e) => setSelectedDestination(e.target.value)}
              style={{ width: '100%', padding: '1rem', borderRadius: '10px', border: '2px solid rgba(255,255,255,0.3)', background: 'rgba(255,255,255,0.1)', color: 'white', fontSize: '1rem', marginBottom: '2rem' }}
            >
              <option value="">Select your destination...</option>
              <optgroup label="🧘 Spiritual & Wellness">
                <option value="India">India - Sacred temples & ashrams</option>
                <option value="Nepal">Nepal - Himalayan monasteries</option>
                <option value="Bali">Bali - Tropical wellness retreats</option>
                <option value="Thailand">Thailand - Spa & mindfulness</option>
              </optgroup>
              <optgroup label="🏔️ Adventure & Nature">
                <option value="Iceland">Iceland - Glaciers & Northern Lights</option>
                <option value="Peru">Peru - Andes & Machu Picchu</option>
                <option value="New Zealand">New Zealand - Epic landscapes</option>
              </optgroup>
              <optgroup label="🌍 Cultural Experiences">
                <option value="Morocco">Morocco - Ancient traditions</option>
                <option value="Japan">Japan - Zen culture & traditions</option>
                <option value="Italy">Italy - Art, history & cuisine</option>
                <option value="Greece">Greece - Ancient wisdom & islands</option>
              </optgroup>
            </select>

            <div style={{ display: 'flex', gap: '1rem' }}>
              <button className="nav-btn" onClick={() => setShowDestinationCard(false)} style={{ flex: 1, padding: '1rem' }}>← Back</button>
              <button className="nav-btn primary" onClick={proceedWithDestination} style={{ flex: 2, padding: '1rem', fontSize: '1rem' }} disabled={!selectedDestination}>🌟 Create My Journey</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showResults) {
    return (
      <div className="assessment">
        <div className="container">
          <div className="results-card active">
            <h2>🎯 Your Travel Profile</h2>
            <div className="ai-analysis">
              <h3>AI Analysis Complete</h3>
              <p>Based on your responses, here's your personalized travel profile.</p>
            </div>

            <div className="personality-match">
              <div className="match-item">
                <div className="match-score">{scores.spiritual}%</div>
                <div className="match-label">Spiritual</div>
              </div>
              <div className="match-item">
                <div className="match-score">{scores.adventure}%</div>
                <div className="match-label">Adventure</div>
              </div>
              <div className="match-item">
                <div className="match-score">{scores.cultural}%</div>
                <div className="match-label">Cultural</div>
              </div>
              <div className="match-item">
                <div className="match-score">{scores.wellness}%</div>
                <div className="match-label">Wellness</div>
              </div>
            </div>

            <h3 style={{ marginTop: '2rem', marginBottom: '1rem', textAlign: 'center' }}>Choose Your Journey Style:</h3>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              <button className="nav-btn primary" onClick={() => selectJourneyStyle('ai-surprise')} style={{ flex: 1, padding: '1.2rem', fontSize: '1rem' }}>🤖 Surprise Me</button>
              <button className="nav-btn primary" onClick={() => selectJourneyStyle('user-destination')} style={{ flex: 1, padding: '1.2rem', fontSize: '1rem' }}>🌍 I Know Where I Want to Go</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="assessment">
      <div className="container">
        <div className="assessment-header">
          <h1>🧠 Quick Travel Assessment</h1>
          <p>10 simple questions to find your perfect journey</p>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }}></div>
          </div>
          <div id="progress-text">Question {currentQuestion} of {totalQuestions}</div>
        </div>

        <div className="question-card active">
          <div className="question-number">QUESTION {currentQuestion} OF {totalQuestions}</div>
          <div className="question-title">{question.title}</div>

          <div className="options-grid">
            {question.options.map(option => (
              <div
                key={option.value}
                className={`option-btn ${answers[currentQuestion] === option.value ? 'selected' : ''}`}
                onClick={() => selectOption(option.value)}
              >
                <div className="option-icon">{option.icon}</div>
                <div className="option-content">
                  <div className="option-title">{option.title}</div>
                  <div className="option-description">{option.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="navigation">
          <button className="nav-btn" onClick={previousQuestion} disabled={currentQuestion === 1}>← Back</button>
          <button className="nav-btn primary" onClick={nextQuestion} disabled={!answers[currentQuestion]}>
            {currentQuestion === totalQuestions ? 'Complete' : 'Next →'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransformationAssessment;
